import styled from 'styled-components';

export const Container = styled.div`
    background-color: var(--color-black);

    h3 {
        color: var(--color-yellow);
    }
`;
